// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/sticky/index.css
// module id = 450
// module chunks = 32